import { useQuery } from '@tanstack/react-query';

import type { User } from '@/types/v2/user';
import axios from '@/lib/v2/axios';
import { useUser } from '@/hooks/v2/use-user';

import { AccountDetailsCard } from './components/account-details-card';

interface AccountsApiResponse {
  managers: User[];
}

export default function Accounts() {
  const { user, account } = useUser();
  const { data } = useQuery<AccountsApiResponse>({
    queryKey: ['managers', user?.selected_community_id],
    queryFn: async () => {
      const response = await axios.get<AccountsApiResponse>(`/api/v2/communities/${user?.selected_community_id}/managers`);
      return response.data;
    },
  });
  console.log(data);

  if (!account) {
    return <div>No account selected</div>;
  }

  return (
    <div>
      <AccountDetailsCard account={account} />
    </div>
  );
}
